import React from "react";
import { TemplateId, TemplateProps } from "./BaseTemplate";

// Import wszystkich szablonów
import ModernTemplate from "./templates/ModernTemplate";
import ClassicTemplate from "./templates/ClassicTemplate";
import MinimalTemplate from "./templates/MinimalTemplate";
import LuxuryTemplate from "./templates/LuxuryTemplate";
import CompactTemplate from "./templates/CompactTemplate";

const TEMPLATE_COMPONENTS = {
  modern: ModernTemplate,
  classic: ClassicTemplate,
  minimal: MinimalTemplate,
  luxury: LuxuryTemplate,
  compact: CompactTemplate,
};

interface TemplateProviderProps extends TemplateProps {
  templateId?: TemplateId;
}

const TemplateProvider: React.FC<TemplateProviderProps> = ({
  templateId = "modern",
  ...props
}) => {
  const TemplateComponent = TEMPLATE_COMPONENTS[templateId];

  if (!TemplateComponent) {
    console.warn(`Template "${templateId}" not found, falling back to modern`);
    return <ModernTemplate {...props} />;
  }

  return <TemplateComponent {...props} />;
};

export default TemplateProvider;
